import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { environment } from 'environments/environment';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

/** Aggiunge l'indirizzo dell'API alle richieste relative ("api/...", "image-service/...") e il token JWT. */
const isApiCall = (url: string): boolean => url.startsWith('api/') || url.startsWith('image-service/');

const withAuth = (req: HttpRequest<unknown>, token: string): HttpRequest<unknown> =>
{
    let request = req;

    if ( isApiCall(req.url) )
    {
        request = request.clone({url: `${environment.apiUrl}/${req.url}`});
    }

    if ( token && !AuthUtils.isTokenExpired(token) && request.url.startsWith(environment.apiUrl) )
    {
        request = request.clone({headers: request.headers.set('Authorization', 'Bearer ' + token)});
    }

    return request;
};

export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    const authService = inject(AuthService);
    const router = inject(Router);
    const isAuthEndpoint = /api\/auth\/(login|refresh|forgot-password|reset-password|confirm-email)/.test(req.url);

    // se il token sta per scadere lo si rinnova prima di inviare la richiesta
    const needsRefresh = !isAuthEndpoint && isApiCall(req.url) && !!authService.accessToken && !!authService.refreshToken
        && AuthUtils.isTokenExpired(authService.accessToken, 30);

    const send = (): Observable<HttpEvent<unknown>> => next(withAuth(req, authService.accessToken)).pipe(
        catchError((error) =>
        {
            // sessione non più valida: nuova autenticazione
            if ( error instanceof HttpErrorResponse && error.status === 401 && !isAuthEndpoint )
            {
                authService.signOut().subscribe(() => router.navigate(['/sign-in']));
            }

            return throwError(() => error);
        }),
    );

    if ( needsRefresh )
    {
        return authService.refresh().pipe(switchMap(() => send()));
    }

    return send();
};
